var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer-main"},[(_vm.backendLayout === 'HeroImage' || _vm.backendLayout === 'Default' || _vm.backendLayout === 'Jobmarket'|| _vm.backendLayout === 'NewsDetail')?_c('PageFooterGoogleMap'):_vm._e(),_vm._v(" "),_c('PageFooterLinks')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }